import React, { useState } from "react";
import { CardContainer } from "./CardContainer";
import { CardStat } from "./CardComps";
import LaunchIcon from "@mui/icons-material/Launch";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import routes from "../../constants/routes";
import dayjs from "dayjs";

const AssetCard = ({ data,edit, remove }) => {
  const [menu, setMenu] = useState(null)
  const openMenu = (event) => setMenu(event.currentTarget)
  const closeMenu = () => setMenu(null)

  return (
    <CardContainer
      disableEditDelete
      SummaryContent={
        <>
          <CardStat label="Name" value={data?.name} />
          <CardStat label="Status" value={data?.status} />
          <CardStat
            label="Price"
            value={data?.currency + " " + data?.price?.toFixed(2)}
          />
          <CardStat
            label="Created at"
            value={
              data?.creationTimestamp
                ? dayjs(data.creationTimestamp).format("MMM DD, YYYY | H:mm a")
                : "-"
            }
          />
        </>
      }
      DetailsContent={
        <>
          <CardStat label="Model" value={data?.model} />
          <CardStat label="Serial Number" value={data?.serialNumber} />
        </>
      }
      ActionButtons={
        <>
          <Link to={`${routes.ADMIN.FACULTIES}/${data?.teacherUser}`}>
            <IconButton>
              <LaunchIcon />
            </IconButton>
          </Link>
          <IconButton onClick={openMenu}>
            <MoreVertIcon />
          </IconButton>
        </>
      }
    >
      <Menu anchorEl={menu} open={Boolean(menu)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            edit();
            closeMenu();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            remove();
            closeMenu();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </CardContainer>
  );
};

export default AssetCard;
